import { render, staticRenderFns } from "./removeDialog.vue?vue&type=template&id=09bc1cd6&scoped=true"
import script from "./removeDialog.vue?vue&type=script&lang=js"
export * from "./removeDialog.vue?vue&type=script&lang=js"
import style0 from "./removeDialog.vue?vue&type=style&index=0&id=09bc1cd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bc1cd6",
  null
  
)

export default component.exports